import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';

export const useCreateEvent = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const createEventHook = async (event, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.post(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}qalbox-admin-event-service/v1/create/`,
        {event}
      );

      const json = response?.data;
      if (json?.payload) {
        setSuccess(true);
        handleUpdate(json?.payload);
      } else {
        setError("Failed to create event");
      }
    } catch (error) {
      setError("An error occurred while creating event");
    } finally {
      setLoading(false);
    }
  };

  return [ createEventHook, loading, error, success ];
};